import {Component, EventEmitter, Input, OnInit, Output, inject, ChangeDetectorRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BaseComponent, SearchComponent, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsDialogHeaderComponent,
  WmsSplitPaneComponent, WmsSplitPanelComponent, LiveWidgetsFieldsListComponent, WmsDialogComponent, WmsCriteriaBuilderComponent } from '@wms/components';
import { FilterPipe } from '@wm/components-base';
import { extend, find, forEach, includes, isEmpty, map, replace, toLower, toString, upperCase, without, pull, each, set } from 'lodash-es';
import { FormsModule } from '@angular/forms';
import { PropertiesTemplateComponent } from '@wms/properties-panel';
import { LiveWidgetUtilsService } from '@wms/app/services/liveWidgetUtils/live-widget-utils.service';
import { LiveWidgetSettingsService } from '@wms/app/services/liveWidgetsSettings/live-widget-settings.service';
import { extractType, getWidgetRolesArrayFromStr, StudioUtils } from '@wms/core';
import { getClonedObject, getVariableNameFromExpr, isDefined } from '@wm/core';
import { getVariableByName } from '@wms/variables';
import { WidgetDesignerComponent } from "@wms/app/design-container/widget-designer.component";
import { TypeFactoryService } from "@wms/services";
import { setDisplayFlags } from '@wm/design-runtime';
import { SecurityComponent } from '@wms/components';
import { ActionsBasicComponent } from '../runtime/components/actions-basic/actions-basic.component';
import { FormFilterBasicComponent } from '../runtime/components/form-filter-basic/form-filter-basic.component';
import { WmsIconSelectorComponent } from '@wms/app/components/wms-icon-selector/wms-icon-selector.component';
import { WmsExpressionErrorDirective } from '@wms/app/directives/wms-expression-error/wms-expression-error.directive';
import {WidgetPropertiesProvider} from "@wms/app/design-container";

let formFields: any[];
@Component({
  selector: 'wms-form-designer',
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    TabsModule,
    SearchComponent,
    WmsSplitPanelComponent,
    WmsSplitPaneComponent,
    TooltipModule,
    FilterPipe,
    SearchComponent,
    FormsModule,
    PropertiesTemplateComponent,
    LiveWidgetsFieldsListComponent,
    FormFilterBasicComponent,
    SecurityComponent,
    ActionsBasicComponent,
    WmsIconSelectorComponent,
    WmsDialogComponent,
    WmsCriteriaBuilderComponent,
    WmsExpressionErrorDirective
  ],
  templateUrl: './form-designer.component.html',
  styleUrls: ['./form-designer.component.less'],
  providers: [LiveWidgetSettingsService]
})
export class FormDesignerComponent extends BaseComponent implements OnInit {

  @Input() propPanelInfo: any;
  @Input() activeWidgetType: any;
  @Output() handleClose = new EventEmitter<any>();
  liveWidgetUtils: LiveWidgetUtilsService;
  liveWidgetSettingsService: LiveWidgetSettingsService;
  toUpperCase = upperCase;
  convertToString = toString;
  everyoneRole = ['Everyone'];
  formButtons: any;
  fieldsKey: any = '';
  actionSearchKey: string = '';
  myWidgets: any = {};
  private selectedIndex: number | undefined;
  private selectedComponentType: string;

  private dialogDesigner: WidgetDesignerComponent;
  private typeService: TypeFactoryService;
  private variableName: string;

  constructor(private cdr: ChangeDetectorRef, private widgetPropertiesProvider: WidgetPropertiesProvider) {
    super();
    this.liveWidgetUtils = inject(LiveWidgetUtilsService);
    this.liveWidgetSettingsService = inject(LiveWidgetSettingsService);
    this.dialogDesigner = inject(WidgetDesignerComponent);
    this.typeService = inject(TypeFactoryService);
  }

  ngOnInit(): void {
    this.liveWidgetSettingsService.initSettings(this.propPanelInfo, this.activeWidgetType).then(success => {
      this.variableName = this.liveWidgetSettingsService.activeWidgetScope.binddataset && getVariableNameFromExpr(this.liveWidgetSettingsService.activeWidgetScope.binddataset);
      this.formButtons = this.liveWidgetUtils.getLiveWidgetButtons(this.activeWidgetType === 'wm-form' ? 'FORM' : 'LIVEFORM');
      let isLiveform = this.liveWidgetSettingsService.activeWidgetScope.isLiveform;
      let tagName = isLiveform ? 'wm-liveform' : 'wm-form';
      formFields = this.liveWidgetSettingsService.getOrderedFieldsBasedOnMarkUp((pull(this.liveWidgetSettingsService.activeWidgetScope.formFields, undefined)), 'wm-form-field', tagName);
      this.myWidgets = this.widgetPropertiesProvider.getSubGroup('Mywidgets', 'custom-widgets').widgets;
      if (isLiveform) {
        this.initLiveFormDesigner();
      } else {
        this.initFormDesigner();
      }
    })
  }

  searchFields($event: any) {
    this.fieldsKey = $event.searchKey;
  }

  searchActions = (event: any) => {
    this.actionSearchKey = event.searchKey;
  }

  //function to add new custom component
  addCustomComponent = (componentType: any, updateMode?: boolean) => {
    let customKey = this.liveWidgetUtils.getCustomFieldKey(this.liveWidgetSettingsService.componentDefnObject[componentType], 'key', 'custom');
    if (componentType === 'field') {
      this.liveWidgetSettingsService.componentDefnObject[componentType] = [...this.liveWidgetSettingsService.componentDefnObject[componentType],{
        'key': customKey,
        'displayname': 'Custom ' + componentType,
        'show': true,
        'pcDisplay': true,
        'mobileDisplay': true,
        'tabletDisplay': true,
        'type': 'string',
        'widgetTypeOptions': this.liveWidgetSettingsService.fieldTypeWidgetTypeMap.custom,
        'allowBinding': true,
        'accessroles': this.everyoneRole
      }];
      this.liveWidgetSettingsService.updateSelectAll('field', 'pcDisplay');
      this.liveWidgetSettingsService.updateSelectAll('field', 'mobileDisplay');
      this.liveWidgetSettingsService.updateSelectAll('field', 'tabletDisplay');
    } else {
      this.liveWidgetSettingsService.componentDefnObject[componentType] =[...this.liveWidgetSettingsService.componentDefnObject[componentType],{
        'key': customKey,
        'displayName': 'Custom ' + componentType,
        'include': true,
        'show': 'true',
        'type': 'button',
        'updateMode': this.activeWidgetType === 'wm-form' ? true : updateMode,
        'shortcutkey': '',
        'class': 'btn-secondary',
        'position': 'footer',
        'widgetType': 'button',
        'accessroles': this.everyoneRole,
      } ];
      this.liveWidgetSettingsService.updateSelectAll('button', 'include');
    }
    this.updateSelectedComponent(this.liveWidgetSettingsService.componentDefnObject[componentType][this.liveWidgetSettingsService.componentDefnObject[componentType].length - 1], componentType);
  };

  // before saving this will just get the selectedComponent details and update on componentDefObj
  assignSelectedComponentInfo() {
    if (this.selectedComponentType) {
      let previousSelected = this.liveWidgetSettingsService.selectedComponent[this.selectedComponentType];
      let index = this.liveWidgetSettingsService.componentDefnObject[this.selectedComponentType].findIndex((comp: any) => comp.key === previousSelected.key);
      if (index !== -1) {
        this.liveWidgetSettingsService.componentDefnObject[this.selectedComponentType][index] = previousSelected;
      }
    }
  }

  //function to update selected column on click of a column in UI
  updateSelectedComponent = (componentDef: any, componentType: any, index?: number, $event?: any) => {
    if (!componentDef) { //if no variable is binded or empty dataset is binded then return back
      return;
    }
    if (index !== this.selectedIndex) {
      let previousSelected = this.liveWidgetSettingsService.selectedComponent[componentType];
      let itemIndex = this.liveWidgetSettingsService.componentDefnObject[componentType].findIndex((comp: any) => comp.key === previousSelected.key);
      if (itemIndex !== -1) {
        this.liveWidgetSettingsService.componentDefnObject[componentType][itemIndex] = previousSelected;
      }
    }

    if (componentType === 'field') {
      componentDef.ngClasses = this.liveWidgetUtils.parseNgClasses(componentDef.ngclass);
      this.liveWidgetSettingsService.setDragHandle($event);
    }
    this.liveWidgetSettingsService.selectedComponent[componentType] = {};
    this.liveWidgetSettingsService.selectedComponent[componentType] = componentDef;
    this.liveWidgetSettingsService.focusSelectedComponent();
    this.liveWidgetSettingsService.getOtherWdgtTypes(componentDef.widgetTypeOptions);
    this.selectedIndex = isDefined(index) ? index : undefined;
    this.selectedComponentType = componentType;
    if (componentType === 'field') {
      if (!this.liveWidgetSettingsService.selectedComponent[componentType].displaywidget) {
        this.liveWidgetSettingsService.selectedComponent[componentType].displaywidget = this.liveWidgetSettingsService.selectedComponent[componentType].widget;
      }
      this.liveWidgetSettingsService.widgetTypeOptionsSubject.next();
    }
    this.cdr.detectChanges();
  }

  showPropertyInSubGroup = (property: any) => {
    return this.liveWidgetSettingsService.activeWidgetScope?.widgetProps[property]?.showindesigner;
  }

  //function to initialize the live form designer with the required data
  initFormDesigner() {
    let title: any,
      defaultFields: any = [],
      defaultKeys: any = [],
      fields: any = [],
      variable: any,

      // Generate the field defs merging the existing fields and new fields
      populateFields = () => {
        //Loop through the fields present in markup
        forEach(formFields, (field: any) => {
          //backward compatibility for old projects if key contains variable name replace it
          if (variable && variable.category === 'wm.Variable' && includes(field.key, variable.name + '.')) {
            field.key = field.key.replace(variable.name + '.', '');
          }
          if (!field.showMatch) {
            field.match = '';
          }
          field.displaywidget = field.displaywidget === 'typeahead' ? 'autocomplete' : field.displaywidget === 'custom-widget' ? (find(this.myWidgets, (myWidget) => myWidget.defaults.widgetName === field.widgetname)) : field.displaywidget;
          field.displaywidget = field.displaywidget || this.liveWidgetSettingsService.fieldTypeWidgetTypeMap[field.type || 'custom'][0];
          field.widgetTypeOptions = this.liveWidgetSettingsService.fieldTypeWidgetTypeMap[field.type || 'custom'];
          fields.push(field);
          defaultKeys = without(defaultKeys, field.key); //As field is already present, remove from the default fields
        });
        //Loop through the new fields and show it in the form designer
        forEach(defaultKeys, (key: any) => {
          let field,
            type,
            fieldName;
          if (title) {
            field = find(defaultFields, { 'columnName': key });
            fieldName = field.columnName;
            type = extractType(field.type);
          } else {
            field = find(defaultFields, { 'field': key });
            fieldName = field.field;
            type = field.type;
          }
          type = toLower(extractType(type));
          fields.push({
            'name': replace(fieldName, '.', '_'),
            'key': fieldName,
            'type': type,
            'displayname': field.displayName,
            'displaywidget': field.widget,
            'widgetTypeOptions': this.liveWidgetSettingsService.fieldTypeWidgetTypeMap[type || 'custom'],
            'show': true
          });
        });
        this.liveWidgetSettingsService.componentDefnObject.field = this.getFieldsCopy(fields);
        if (isEmpty(this.liveWidgetSettingsService.componentDefnObject.field)) {
          return;
        }
        this.addFormButton();
      };

    this.liveWidgetSettingsService.fieldsList = this.liveWidgetSettingsService.getFieldsList();
    if (includes(this.liveWidgetSettingsService.activeWidgetScope.binddataset, 'bind:Variables.')) {
      variable = getVariableByName(this.variableName);
    }
    if (variable) {
      //If form variable is found, fetch the fields present in the variable
      // TO-DO getPrimitiveFieldsForType FIX method.
      (StudioUtils.getPrimitiveFieldsForType(variable) as Promise<any>).then((serviceInfo: any) => {
        if (serviceInfo.primitiveParams.length) {
          defaultFields = serviceInfo.primitiveParams;
          defaultKeys = map(defaultFields, 'field');
        } else if (serviceInfo.columns.length) {
          defaultFields = serviceInfo.columns[0].fields;
          title = serviceInfo.columns[0].title;
          //for crud variables remove the body param name from keys. e.g. replace employee.age to age
          if (variable.category === 'wm.CrudVariable') {
            defaultFields = each(defaultFields, (val: any) => {
              val.columnName = val.columnName.replace(title + '.', '');
            });
          }
          defaultKeys = map(defaultFields, 'columnName');
        }
        populateFields();
      });
    } else {
      populateFields();
    }
  }

  initLiveFormDesigner() {

    /*get the live variable bound to the live form*/
    let Obj = {},
      orderedFieldArray: any[] = [],
      hiddenFields: any[] = [],
      variable: any;

    //Get the bound variable of live form
    if (this.liveWidgetSettingsService.activeWidgetScope.variableObj) {
      variable = this.liveWidgetSettingsService.activeWidgetScope.variableObj;
    } else {
      // TODO:
      // variable = this.liveWidgetSettingsService.activeWidgetScope.Variables[this.liveWidgetSettingsService.activeWidgetScope.variableName || getVariableByName(this.liveWidgetSettingsService.activeWidgetScope)];
      variable = getVariableByName(this.variableName);
    }

    this.liveWidgetSettingsService.fieldsList = this.liveWidgetSettingsService.getFieldsList();

    set(Obj, 'propertiesMap', variable ? variable.propertiesMap : undefined);
    this.liveWidgetSettingsService.relatedColumnObject = {};
    /*Use the live form translate method to transform the result to consumable form*/
    this.liveWidgetSettingsService.componentDefnObject.field = this.liveWidgetUtils.translateVariableObject(Obj);
    hiddenFields = map(this.liveWidgetSettingsService.componentDefnObject.field, 'key');
    this.liveWidgetSettingsService.filterFields = getClonedObject(hiddenFields);
    this.liveWidgetSettingsService.componentDefnObject.defaultFields = getClonedObject(hiddenFields);
    //Loop over the fields form the markup
    forEach(formFields, (datum) => {
      let field = find(this.liveWidgetSettingsService.componentDefnObject.field, { 'key': datum.key });
      //If field is present in variable fields, set properties from markup. Otherwise add the markup field.
      if (field) {
        if (field.isRelated) {
          this.liveWidgetSettingsService.relatedColumnObject[field.key] = this.typeService.getFieldsForExpr(this.liveWidgetSettingsService.activeWidgetScope.binddataset + '.' + field.key);
          let fieldObj = find(variable.propertiesMap.columns, (o) => { return o.fieldName == field.key; });
          /**
           * filter-columns: Query builder, needs the filter field columns for the query.
           * For live form, attaching the columns for the respective entity which can be used to pass these columns to the Query builder
           */
          this.liveWidgetSettingsService.relatedColumnObject[field.key + "_columns"] = this.dialogDesigner.getCriteriaFilterFields(this.dialogDesigner.getTypeForTheEntity(variable, fieldObj.relatedEntityName));
          field.matchmode = variable.matchMode;
          this.liveWidgetSettingsService.showGroupByProperties(datum);
          this.liveWidgetSettingsService.relatedColumnObject[field.key + "_groupByDisplayOptions"] = this.dialogDesigner.getGroupbyDisplayOptions(this.liveWidgetSettingsService.relatedColumnObject[field.key]);
        }
        forEach(datum, (value, key) => {
          field[key] = value;
        });
        datum.widget = datum.widget === 'typeahead' ? 'autocomplete' : datum.widget;
        field.widget = datum.widget || this.liveWidgetSettingsService.fieldTypeWidgetTypeMap[datum.type][0];
        if(field.displaywidget === 'custom-widget')
          field.displaywidget = find(this.myWidgets, (myWidget) => myWidget.defaults.widgetName === field.widgetname);
        field.widgetTypeOptions = this.liveWidgetSettingsService.fieldTypeWidgetTypeMap[field.type];
        if (field.primaryKey && field.primaryKey.toString() === 'true') {
          //Disable deletion for primary key fields
          field._isDeleteDisabled = field.pcDisplay = field.mobileDisplay = field.tabletDisplay = true;
        }
        field.filterOn = datum.dataset ? undefined : datum.filterOn;
        if (!field.showMatch) {
          field.match = '';
          datum.match = '';
        }
        orderedFieldArray.push(field);
        hiddenFields = pull(hiddenFields, field.key);
      } else {
        datum.widgetTypeOptions = this.liveWidgetSettingsService.fieldTypeWidgetTypeMap[datum.type];
        orderedFieldArray.push(datum);
      }
    });
    //Add fields present in variable but not in markup as hidden fields
    forEach(hiddenFields, (key) => {
      let field = find(this.liveWidgetSettingsService.componentDefnObject.field, { 'key': key });
      if (field.isRelated) {
        let fieldObj = find(variable.propertiesMap.columns, (o) => { return o.fieldName == field.key; });
        this.liveWidgetSettingsService.relatedColumnObject[field.key] = this.typeService.getFieldsForExpr(this.liveWidgetSettingsService.activeWidgetScope.binddataset + '.' + field.key);
        this.liveWidgetSettingsService.relatedColumnObject[field.key + "_columns"] = this.dialogDesigner.getCriteriaFilterFields(this.dialogDesigner.getTypeForTheEntity(variable, fieldObj.relatedEntityName));
      }
      if (field.primaryKey && field.primaryKey.toString() === 'true') {
        field._isDeleteDisabled = field.pcDisplay = field.mobileDisplay = field.tabletDisplay = true;
      } else {
        field.pcDisplay = field.mobileDisplay = field.tabletDisplay = false;
      }
      field.widgetTypeOptions = this.liveWidgetSettingsService.fieldTypeWidgetTypeMap[field.type];
      orderedFieldArray.push(field);
    });
    orderedFieldArray = pull(orderedFieldArray, undefined);

    this.liveWidgetSettingsService.componentDefnObject.field = this.getFieldsCopy(orderedFieldArray);
    this.addFormButton();
  }

  getFieldsCopy(fields: Array<any>) {
    let _fields: Array<any> = [];
    forEach(fields, (field: any) => {
      _fields.push(extend({}, field));
    });
    return _fields;
  }

  addFormButton() {
    //check if select all should be selected
    this.liveWidgetSettingsService.updateSelectAll('field', 'pcDisplay');
    this.liveWidgetSettingsService.updateSelectAll('field', 'mobileDisplay');
    this.liveWidgetSettingsService.updateSelectAll('field', 'tabletDisplay');

    this.liveWidgetSettingsService.componentDefnObject.button = (this.liveWidgetSettingsService.activeWidgetScope.buttonArray) ? this.getFieldsCopy([...this.liveWidgetSettingsService.activeWidgetScope.buttonArray]) : [];
    /*Adding 'include' attribute to the buttons,To decide which buttons to be considered while saving designer dialog*/
    each(this.liveWidgetSettingsService.componentDefnObject.button, (butDef: any) => {
      butDef.include = true;
      butDef.accessroles = butDef.accessroles ? getWidgetRolesArrayFromStr(butDef.accessroles) : this.everyoneRole;
    });
    this.formButtons.forEach((button: any) => {
      let isButtonExist = this.liveWidgetSettingsService.componentDefnObject.button.some((obj: any) => {
        return obj.key === button.key;
      });
      if (!isButtonExist) {
        button.include = false;
        this.liveWidgetSettingsService.componentDefnObject.button.push(button);
      }
    });

    if (isEmpty(this.liveWidgetSettingsService.selectedComponent.field)) {
      this.updateSelectedComponent(this.liveWidgetSettingsService.componentDefnObject.field[0], 'field');  //Update the fields and buttons
    }

    if (isEmpty(this.liveWidgetSettingsService.selectedComponent.button)) {
      this.updateSelectedComponent(this.liveWidgetSettingsService.componentDefnObject.button[0], 'button');
    }
    this.liveWidgetSettingsService.updateSelectAll('button', 'include');
  }
 }

